// extracted by mini-css-extract-plugin
var _1 = "VOH2j";
var _2 = "SUnI7";
var _3 = "C8ASZ";
var _4 = "cwfBP";
var _5 = "_o3Qs";
export { _1 as "base", _2 as "fill", _3 as "hint", _4 as "label", _5 as "loading" }
